import { Box } from '@razorpay/blade/components';
import {
  SalaryStructureComponent,
  SalaryStructureComponentValueType,
} from 'components/SalaryStructure/types';
import React from 'react';
import { EarningsSectionProps } from '../types';
import { SalaryComponentItem } from './SalaryComponentItem';

const EarningsSection: React.FC<EarningsSectionProps> = ({
  components,
  onDeleteComponent,
  onUpdateComponent,
}) => {
  // Handle value changes
  const handleValueChange = (id: string, component: SalaryStructureComponent, value: string) => {
    onUpdateComponent(id, {
      ...component,
      formula: value,
    });
  };

  // Handle base changes
  const handleBaseChange = (
    id: string,
    component: SalaryStructureComponent,
    baseString: string,
  ) => {
    onUpdateComponent(id, {
      ...component,
      valueType: baseString as SalaryStructureComponentValueType,
    });
  };

  return (
    <Box display="flex" flexDirection="column" gap="spacing.2">
      {components.map((component) => (
        <SalaryComponentItem
          key={component.salaryComponent.id}
          component={component}
          onValueChange={(value) =>
            handleValueChange(component.salaryComponent.id, component, value)
          }
          onBaseChange={(base) => handleBaseChange(component.salaryComponent.id, component, base)}
          onDelete={() => onDeleteComponent(component.salaryComponent.id)}
        />
      ))}
    </Box>
  );
};

export default EarningsSection;
